import { defineAction } from '~/prix'
import housingMockAction from './residencePublicSafetyMock.action.json' with { type: 'json' }
import { z } from 'zod'

const housingMockDefinition = defineAction({
  ...housingMockAction,

  input: z.object({
    count: z.number().default(50),
    seed: z.number().default(10),
  }),
  output: z.object({}),
})

export default housingMockDefinition
